import { StihlFileDTO } from "./stihl-file-dto";

export class StihlCampaignDTO {
  IdCampaign: string | null;
  IdCampaignClear: string;
  Status: boolean;
  StartDate: string;
  EndDate: string | null;
  Title: string;
  Description: string;
  ImageFile: StihlFileDTO | null;
  PositiveFilters: string[];
  NegativeFilters: string[];
  SubCampaigns: string[];
  ComingSoon: boolean;
  Permanent: boolean;
  ShowCampaigns: boolean;
  ShowAdvExpense: boolean;
  OnlySubCampaign: boolean;
  IsSubCampaignOf: string[]=[];
}

export class StihlCampaignPostDTO {
  Status: boolean;
  StartDate: string;
  EndDate: string | null;
  Title: string;
  Description: string;
  ImageFile: File | null;
  PositiveFilters: string[];
  NegativeFilters: string[];
  SubCampaigns: string[];
  Permanent: boolean;
  ShowCampaigns: boolean;
  ShowAdvExpense: boolean;
  OnlySubCampaign: boolean;
}

export class StihlCampaignMaterialDTO {
  IdCampaignMaterial: string;
  IdCampaign: string;
  IdCampaignMaterialMedia: number;
  IdCampaignMaterialMediaEncrypted: string;
  CampaignMaterialMedia: string;
  CampaignDescription: string;
  Status: boolean;
  Title: string;
  CreationDate: string;
  FileHtmlInfo: StihlFileDTO | null;
  PositiveFilters: string[];
  NegativeFilters: string[];
  OnlyOneOrderPerDistri: boolean;
  OnlyPrincipalDistri: boolean;
  Order: number;
}

export class StihlCampaignMaterialPostDTO {
  IdCampaign: string;
  IdCampaignMaterialMedia: number;
  Status: boolean;
  Title: string;
  CreationDate: string;
  FileHtmlInfo: File | null;
  PositiveFilters: string[];
  NegativeFilters: string[];
  OnlyOneOrderPerDistri: boolean;
  OnlyPrincipalDistri: boolean;
  Order: number;
}

export class StihlCampaignMaterialDataDTO {
  IdCampaignMaterialData: string;
  IdCampaignMaterial: string;
  Status: boolean;
  Title: string;
  CreationDate: string;
  IdCampaignMaterialType: number;
  IdCampaignMaterialPreviewType: number | null;
  IdMailingList: number | null;
  IdRrss: number | null;
  IdSendType: number | null;
  Order: number;
  PubHasLogo: boolean;
  PubCustomPdfDownload: boolean;
  FilePubFilePreview: StihlFileDTO | null;
  FilePubPoster: StihlFileDTO | null;
  FilePubFileDownload: StihlFileDTO | null;
  FilePubFileForm: StihlFileDTO | null;
  CrmSubject: string;
  CrmSubjectEditable: boolean;
  FileCrmHtmlInput: StihlFileDTO | null;
  FileCrmHtmlOutput: StihlFileDTO | null;
  FileCrmPdfEditable: StihlFileDTO | null;
  PositiveFilters: string[];
  NegativeFilters: string[];
  FileRrssIcon: StihlFileDTO | null;
}

export class StihlCampaignMaterialDataPostDTO {
  IdCampaignMaterial: string;
  Status: boolean;
  Title: string;
  CreationDate: string;
  IdCampaignMaterialType: number;
  IdCampaignMaterialPreviewType: number | null;
  IdMailingList: number | null;
  IdRrss: number | null;
  IdSendType: number | null;
  Order: number;
  PubHasLogo: boolean;
  PubCustomPdfDownload: boolean;
  FilePubFilePreview: File | null;
  FilePubPoster: File | null;
  FilePubFileDownload: File | null;
  FilePubFileForm: File | null;
  CrmSubject: string;
  CrmSubjectEditable: boolean;
  FileCrmHtmlInput: File | null;
  FileCrmHtmlOutput: File | null;
  FileCrmPdfEditable: File | null;
  PositiveFilters: string[];
  NegativeFilters: string[];
}

export class StihlCampaignMaterialMediaPostDTO {
  CampaignMaterialMedia: string;
  IdCampaignMaterialMediaType: number;
  Status: boolean;
  PositiveFilters: string[];
  NegativeFilters: string[];
}

export class StihlCampaignMaterialMediaDTO {
  IdCampaignMaterialMedia: string;
  CampaignMaterialMedia: string;
  IdCampaignMaterialMediaType: number;
  Status: boolean;
  Order: number;
  Enabled: boolean;
  PositiveFilters: string[];
  NegativeFilters: string[];
}

export class StihlCampaignMaterialMediaTypePostDTO {
  CampaignMaterialMediaType: string;
  Status: boolean;
  HasLogo: boolean;
}

export class StihlCampaignMaterialMediaTypeDTO {
  IdCampaignMaterialMediaType: string;
  CampaignMaterialMediaType: string;
  Status: boolean;
  HasLogo: boolean;
}

export class StihlCampaignRrssPostDTO {
  CampaignRrss: string;
  FileIcon: File | null;
}

export class StihlCampaignRrssDTO {
  IdCampaignRrss: string;
  CampaignRrss: string;
  FileIcon: StihlFileDTO;
}

export class StihlDistributorLogoMassivePostDTO {
  IdMediaType: number;
  FileZip: File | null;
}

export class StihlDistributorLogoDTO {
  IdLogo: string;
  IdDistributor: string;
  IdCampaignMaterialMediaType: number;
  FileLogo: StihlFileDTO;
  Description: string;
  CampaignMaterialMediaType: string;
}

export class StihlCampaignOrderPubPostDTO {
  IdCampaign: string;
  IdCampaignMaterial: string;
  IdCampaignMaterialMedia: string;
  IdCampaignMaterialData: string;
  IdUser: string;
  IdDistributor: number;
  Data: string;
  IdFileLogo: string;
}

export class StihlCampaignOrderCrmPostDTO {
  IdCampaignOrderCrm: string | null;
  IdCampaign: string;
  IdCampaignMaterial: string;
  IdCampaignMaterialMedia: string;
  IdCampaignMaterialData: string;
  IdUser: string;
  IdDistributor: number;
  IdContactList: number;
  Subject: string;
  Data: string;
  IdFileLogo: string;
  DesiredDate: Date | null;
  Conditions: boolean;
}
export class StihlCampaignOrderPubDTO {
  IdCampaignOrderPub: string;
  IdCampaign: string;
  IdCampaignMaterial: string;
  IdCampaignMaterialMedia: string;
  IdCampaignMaterialData: string;
  IdStatus: number;
  IdUser: string;
  IdDistributor: number;
  Data: string;
  FileName: string;
  FileLogo: StihlFileDTO | null;
  FilePreview: StihlFileDTO | null;
  HasLogo: boolean;
  CanceledComment: string;
  Campaign: string;
  Media: string;
  OrderNumber: number;
}


export class StihlCampaignOrderCrmDTO {
  IdCampaignOrderCrm: string;
  IdCampaign: string;
  IdCampaignMaterial: string;
  IdCampaignMaterialMedia: string;
  IdCampaignMaterialData: string;
  IdStatus: number;
  IdUser: string;
  IdDistributor: number;
  IdContactList: number;
  Subject: string;
  Data: string;
  FileLogo: StihlFileDTO | null;
  DesiredDate: string | null;
  DistributorName: string;
  CampaignName: string;
  MedioName: string;
  NumPedido: number;
  IdSendType: number | null;
  SendDate?: Date;
  CampaignMaterialData: StihlCampaignMaterialDataDTO;
}

export class StihlCampaignOrderCrmSendTestDTO {
  IdCampaignMaterialData: string;
  Subject: string;
  Data: string;
  EmailTest: string | null;
}

export class KeyValue {
  Key:string;
  Value:string;
}

export class KeyValueLabel {
  Key:string;
  Value:string;
  Label:string;
}


export class CampaignStatisticHighlights {
  Total: number;
  Email: number;
  Sms: number;
}

export class StihlCampaignContactListPostDTO {
  IdCampaignSendType: number;
  Name: string;
  fileContact: File | null;
}